/** @format */

import React from 'react'

import { Button, Modal, Select, Input, message } from 'antd'

import Options from './options.json'

export default class ButtonActionsRecipe extends React.Component {
	state = {
		modal: false,
		dataSend: {},
		qfMessage: '',
	}

	componentDidMount() {
		this.setState({
			dataSend: {
				trx_id: this.props.trx_id,
				status: this.props.status,
				code_internal: this.props.code_internal,
			},
		})
	}

	handleSelectChange = (item) => {
		this.setState((state) => ({ dataSend: { ...state.dataSend, reason: item } }))
	}

	handleReason = (item) => {
		this.setState((prevState) => ({
			dataSend: {
				...prevState.dataSend,
				reason: {
					...prevState.dataSend.reason,
					value: item.target.value,
				},
			},
		}))
	}

	handleTextAreaChange = (item) => {
		console.log('item ', item.target.value)
		this.setState((prevState) => ({
			dataSend: {
				...prevState.dataSend,
				qfMessage: item.target.value,
			},
		}))
	}

	handleModalRecipe = (item) => {
		if (this.state.dataSend.reason?.value === '')
			return message.error('Debe escribir un motivo de Rechazo.')
		this.setState({ modal: false })
		this.props.handleAcceptOrRejectRecipe(this.state.dataSend)
		return this.props.setModal(false)
	}

	render() {
		return (
			<>
				<Button
					onClick={() => this.setState({ modal: true })}
					type='primary'
					icon={this.props.icon}
					danger={this.props.danger}>
					{this.props.labelName}
				</Button>
				<Modal
					title={
						this.props.status === 'RA' || this.props.status === 'RA-QF'
							? 'Aprobar el recipe'
							: '¿Cuál es el motivo del rechazo?'
					}
					visible={this.state.modal}
					onOk={this.handleModalRecipe}
					okButtonProps={{ disabled: this.state.disabeOkButton }}
					cancelText='Cerrar'
					onCancel={() => this.setState({ modal: false })}>
					{this.props.status === 'RA' ? (
						'¿Desea aprobar este recipe?'
					) : this.props.status === 'RA-QF' ? (
						<>
							<Input.TextArea
								placeholder='Escriba su justificación para aprobar la receta'
								onChange={this.handleTextAreaChange}
							/>
						</>
					) : (
						<>
							<Select
								showSearch
								placeholder='Motivo de rechazo'
								labelInValue
								style={{ width: '100%' }}
								onChange={(item) => this.handleSelectChange(item)}
								filterOption={(input, option) =>
									option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
								}>
								{Options.invalidReasons.map((reason) => (
									<Select.Option key={reason.type} value={reason.type}>
										{reason.type}
									</Select.Option>
								))}
							</Select>
							<br />
							<br />
							<Input.TextArea placeholder='Comentario interno' onChange={this.handleReason} />
						</>
					)}
				</Modal>
			</>
		)
	}
}
